import { render } from "./CustomerDetailModal.vue?vue&type=template&id=ab3914fa&scoped=true"
import script from "./CustomerDetailModal.vue?vue&type=script&lang=js"
export * from "./CustomerDetailModal.vue?vue&type=script&lang=js"

import "./CustomerDetailModal.vue?vue&type=style&index=0&id=ab3914fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab3914fa"]])

export default __exports__